import classNames from 'classnames'
import { PropsWithChildren } from 'react'

import styles from './Title.module.scss'

interface IProps extends PropsWithChildren {
  size: 'h3' | 'paragraph'
  align: 'left' | 'right' | 'center'
  variant: 'withBackground' | 'withLightBackground' | 'default'
}

export const SizedTitle = ({ size, children, variant }: IProps) => {
  const mods = {
    [styles.whiteTitle]: variant === 'withBackground',
    [styles.blackTitle]: variant === 'withLightBackground',
  }
  const titleElement =
    size === 'h3' ? (
      <h3 className={classNames(styles.title, styles.margin, { ...mods })}>{children}</h3>
    ) : (
      <div className={classNames(styles.title, styles.margin, { ...mods })}>{children}</div>
    )

  return titleElement
}
